import AppointmentCard from "./AppointmentCard";

export default AppointmentCard;
